<script lang="ts" setup>
    import DButton from "../atoms/DButton.vue";

    import {useAudioPlayer} from "../composables/useAudioPlayer";

    import {isString, isArray} from "@songfinch/utils/src/validators";

    import type {
        SongType,
        ComponentThemes,
        ButtonSizes,
    } from "@songfinch/types";


    const props = withDefaults(
        defineProps<{
            song: SongType;
            variant: "icon" | "circle";
            size: ButtonSizes
            artistName?: string;
            dataTestId: string;
            theme: ComponentThemes;
            startTime?: number;
            endTime?: number;
        }>(),
        {
            variant: "icon",
            size: "medium",
            dataTestId: "DAudioSongPlayer",
            artistName: "",
            startTime: undefined,
            endTime: undefined,
        },
    );

    const normalizedSongMetaObject =  () => {
        let genres = "";
        if (isString(props.song.genres)) genres = props.song.genres;
        if (isArray(props.song.genres))  genres = props.song.genres.join(", ");
        
        return {
            artist: props.song.artist || (props.artistName as string),
            genres,
            title: props.song.title,
        };
    };

    const { 
        playPauseAudio,
        play,
        stop, 
        isPlaying, 
    } = useAudioPlayer(props.song.url, normalizedSongMetaObject());

    defineExpose({
        play,
        stop
    });
</script>

<template>
    <DButton
        :theme="theme"
        :variant="variant"
        :size="size"
        :icon="isPlaying ? 'pause' : 'play'"
        :data-test-id="dataTestId"
        :disabled="!props.song.url"
        @click.stop.prevent="(e) => playPauseAudio(e, startTime, endTime)"
    />
</template>